import { EmbedAspectRatios, EmbedBasic } from "../../../../src/examples/utilities/Embed";
import * as React from 'react';
export default {
  EmbedAspectRatios,
  EmbedBasic,
  React
};